import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  InputAdornment,
  FormControl, // Needed for Select dropdown
  Select,      // Needed for currency dropdown
  MenuItem,
  Container    // Needed for currency options
  // Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import adCenterApi from '../adCenterApi';
import { showToast, showNextStepPrompt } from '../CoreDataService';

export default function SpendCap() {
  const [capName, setCapName] = useState('');
  const [dailyCapAmount, setDailyCapAmount] = useState('');
  const [currency, setCurrency] = useState('USDB'); // New state for currency, default to USDB
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    if (!capName.trim()) newErrors.capName = 'Name is required.';
    if (!dailyCapAmount || isNaN(dailyCapAmount) || Number(dailyCapAmount) <= 0) newErrors.dailyCapAmount = 'Amount must be greater than 0.';
    if (!currency) newErrors.currency = 'Currency is required.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    const spendCapData = {
      adminUser: localStorage.getItem('uuid'),
      brokerId: localStorage.getItem('brokerId'),
      spendCapsName: capName,
      spendCapsAmount: parseFloat(dailyCapAmount),
      currency: currency,
    };
    try {
      const response = await adCenterApi.post('/addSpendCap', spendCapData);
      if (response.data && response.data.statusCode === 0) {
        showNextStepPrompt('spend-cap', navigate);
        setCapName('');
        setDailyCapAmount('');
        setCurrency('USDB');
        setErrors({});
      } else {
        showToast('error', response.data.message || 'Failed to create spend cap');
      }
    } catch (err) {
      showToast('error', 'Error creating spend cap');
    }
  };

  const handleViewEdit = () => {
    navigate('/viewSpendCaps');
  };

  return (
    <Container maxWidth="lg" sx={{ mb: 6 }}>
      <Box sx={{ width: '100%' }}>
        {/* Header and Button Row */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1 }}>

          <Box>
            <Typography variant="h4" component="h1" fontWeight="bold" color="primary.main">
              Create a Daily Spend Cap
            </Typography>
            <Typography variant="body1" color="text.secondary" mt={0.5} sx={{ fontStyle: 'italic' }}>
              The maximum amount you would like to spend in a day
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleViewEdit}
            sx={{ fontWeight: 'bold', textTransform: 'none', whiteSpace: 'nowrap' }}
          >
            View or Edit your spend caps
          </Button>
        </Box>

        {/* Main Form Card */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            mx: 'auto',
            width: '100%'
          }}
        >
          <Card elevation={4} sx={{ borderRadius: 2 }}>
            <CardContent sx={{ p: { xs: 2, md: 4 } }}>
              <Typography variant="h5" fontWeight="bold" color="text.primary" gutterBottom>
                Spend Cap Details
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={3}>
                Define the daily spending limit for your campaigns.
              </Typography>
              {/* Name Field */}
              <Box mb={3}>
                <TextField
                  fullWidth
                  label="Name"
                  placeholder="What Do you want to call it"
                  variant="outlined"
                  value={capName}
                  onChange={(e) => setCapName(e.target.value)}
                  error={!!errors.capName}
                  helperText={errors.capName}
                />
              </Box>
              {/* Daily Cap Amount Field with Currency Selector */}
              <Box mb={4}>
                <TextField
                  fullWidth
                  label="Spend Cap Amount"
                  type="number"
                  placeholder="10"
                  variant="outlined"
                  value={dailyCapAmount}
                  onChange={(e) => setDailyCapAmount(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FormControl variant="standard" sx={{ m: 0, minWidth: 60 }}>
                          <Select
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value)}
                            disableUnderline
                            sx={{
                              '& .MuiSelect-select': {
                                py: '8px',
                                px: '4px !important',
                                pr: '16px !important',
                              },
                              '& .MuiSvgIcon-root': {
                                right: -5
                              }
                            }}
                          >
                            <MenuItem value="USDB">USDB</MenuItem>
                            {/* <MenuItem value="EUR">EUR</MenuItem>
                          <MenuItem value="GBP">GBP</MenuItem>
                          <MenuItem value="INR">INR</MenuItem> */}
                          </Select>
                        </FormControl>
                      </InputAdornment>
                    ),
                    inputProps: { min: 0 }
                  }}
                  error={!!errors.dailyCapAmount}
                  helperText={errors.dailyCapAmount || 'Enter the maximum amount of USDB you wish to spend per day.'}
                />
              </Box>
              {/* Submit Button */}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={handleSave}
                sx={{ textTransform: 'uppercase', py: 1.5 }}
              >
                Create Spend Cap
              </Button>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Container>

  );
}